import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Slider from 'react-slick';
import FlightSearchFormDestinationPage from "../Components/FlightSearchFormDestinationPage";
import FlightDetailDestination from "../Components/FlightDetailDestination";
import TopAirlines from "../Components/TopAirlines";
import airportsData from '../data/airports.json';

function Destination(){
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100); // Delay in milliseconds
    }, []);
   
    const { 'from-to': fromTo } = useParams(); // Access the combined parameter
    
   let toAirport;
    // Split the parameter to get from and to
    const [from, to] = fromTo.split('-to-');
    
    toAirport = to.replace(/-/g, ' ');

    const holidayPackageslSlider = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        speed: 2000,
        loop:true,
        responsive: [{
             breakpoint: 1000,
             settings: {
                 slidesToShow: 2,
                 arrows: false,
             }
         }, {
             breakpoint: 750,
             settings: {
                 slidesToShow: 1,
                 arrows: false,
             }
         }]
    }

      
    
    return (
        <>
            
            <FlightSearchFormDestinationPage />
            <FlightDetailDestination />
            {/* best tour Starts */}
            <section className="trending pb-6 pt-8">
                <div className="container">
                    <div className="row align-items-center justify-content-between mb-6 ">
                        <div className="col-lg-7">
                            <div className="section-title text-center text-lg-start">
                                
                                <h2 className="mb-1">Best <span className="theme">Tour Routes</span></h2>
                                
                            </div>
                        </div>
                        <div className="col-lg-5">
                        </div>
                    </div>
                    <div className="trend-box">
                        <div className="row item-slider">
                            <Slider {...holidayPackageslSlider} >
                            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                <div className="trend-item rounded">
                                    <div className="trend-image position-relative">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/flights/flight2.jpg`} className="" />
                                    </div>
                                    <div className="trend-content1 position-relative pt-2 bg-white">
                                        <h3 className="mb-1"><a href="flight-grid.html" className="">Tokyo to Male</a></h3>
                                        <p className="mb-3">Roundtrip | 09 Jun 2022 - 16 Jun 2022</p>

                                        <div className="entry-meta d-flex align-items-center justify-content-between">
                                            <div className="entry-author d-flex align-items-center">
                                                <p className="mb-0">From<span className="theme fw-bold fs-5"> $220.00</span> | Per person</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                <div className="trend-item rounded">
                                    <div className="trend-image position-relative">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/flights/flight2.jpg`} className="" />
                                    </div>
                                    <div className="trend-content1 position-relative  pt-2 bg-white">
                                        <h3 className="mb-1"><a href="flight-grid.html" className="">New York to London</a></h3>
                                        <p className="mb-3">Roundtrip | 09 Jun 2022 - 16 Jun 2022</p>

                                        <div className="entry-meta d-flex align-items-center justify-content-between">
                                            <div className="entry-author d-flex align-items-center">
                                                <p className="mb-0">From<span className="theme fw-bold fs-5"> $415.00</span> | Per person</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                <div className="trend-item rounded">
                                    <div className="trend-image position-relative">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/flights/flight2.jpg`} className="" />
                                    </div>
                                    <div className="trend-content1 position-relative  pt-2 bg-white">
                                        <h3 className="mb-1"><a href="flight-grid.html" className="">Instanbul to Paris</a></h3>
                                        <p className="mb-3">Roundtrip | 09 Jun 2022 - 16 Jun 2022</p>

                                        <div className="entry-meta d-flex align-items-center justify-content-between">
                                            <div className="entry-author d-flex align-items-center">
                                                <p className="mb-0">From<span className="theme fw-bold fs-5"> $310.00</span> | Per person</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                <div className="trend-item rounded">
                                    <div className="trend-image position-relative">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/flights/flight2.jpg`} className="" />
                                    </div>
                                    <div className="trend-content1 position-relative  pt-2 bg-white">
                                        <h3 className="mb-1"><a href="flight-grid.html" className="">New York to California</a></h3>
                                        <p className="mb-3">Roundtrip | 09 Jun 2022 - 16 Jun 2022</p>

                                        <div className="entry-meta d-flex align-items-center justify-content-between">
                                            <div className="entry-author d-flex align-items-center">
                                                <p className="mb-0">From<span className="theme fw-bold fs-5"> $220.00</span> | Per person</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
            {/* best tour Ends */}    

             {/*Keywords*/}
            
            <div className="row">
                <ul className="keywordsList">
                    <li>
                        Cheap Flights to {toAirport}
                    </li>    
                    <li>
                        Flights to {toAirport}
                    </li>
                    <li>
                        Cheap Tickets to {toAirport}
                    </li>
                    <li>
                        Cheap Flights From London Heathrow to {toAirport}
                    </li>
                    <li>
                        Manchester to {toAirport} Cheap Flights
                    </li>
                    
                    <li>
                        Business Class Deals for {toAirport}
                    </li>
                    <li>
                        Cheap Ticket Prices for {toAirport}
                    </li>
                    <li>
                        Cheap Flights From Birmingham to {toAirport}
                    </li>
                    <li>
                        Umrah Deals
                    </li>
                    <li>
                        Umrah Packages
                    </li>
                    <li>
                        Last Minute Deals
                    </li>
                    <li>
                        Summer Flight Deals
                    </li>
                </ul>
            </div>   
            {/* Top Airlines Start */}
            <TopAirlines />      
            {/* Top Airlines End */} 

            
                
        </>
    )
}
export default Destination;    